import React, { useState } from "react";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import FormatListBulletedRoundedIcon from "@mui/icons-material/FormatListBulletedRounded";
import { IconButton, Typography, Stack } from "@mui/material";

type VisualizacaoTipo = "card" | "list";

interface VisualizacaoToggleProps {
  onChange?: (tipo: VisualizacaoTipo) => void;
}

const buttonBaseStyle = {
  border: "1px solid #0A0C33",
  borderRadius: "6px",
  padding: 2,
  minWidth: "auto",
  margin: 0,
  lineHeight: 1,
};

const VisualizacaoToggle: React.FC<VisualizacaoToggleProps> = ({
  onChange,
}) => {
  const [view, setView] = useState<VisualizacaoTipo>("list");

  const handleChange = (tipo: VisualizacaoTipo) => {
    setView(tipo);
    if (onChange) {
      onChange(tipo);
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <Typography
        variant="subtitle1"
        fontWeight={700}
        style={{ color: "#0A0C33", marginRight: "6px" }}
      >
        Visualização
      </Typography>
      <IconButton
        style={{
          ...buttonBaseStyle,
          backgroundColor: view === "card" ? "#0A0C33" : "transparent",
        }}
        onClick={() => handleChange("card")}
        color={view === "card" ? "primary" : "default"}
        aria-label="Visualizar em cards"
      >
        <GridViewRoundedIcon
          fontSize="medium"
          style={{ color: view === "card" ? "#FFFFFF" : "#0A0C33" }}
        />
      </IconButton>
      <IconButton
        style={{
          ...buttonBaseStyle,
          marginLeft: "6px",
          backgroundColor: view === "list" ? "#0A0C33" : "transparent",
        }}
        onClick={() => handleChange("list")}
        color={view === "list" ? "primary" : "default"}
        aria-label="Visualizar em lista"
      >
        <FormatListBulletedRoundedIcon
          fontSize="medium"
          style={{ color: view === "list" ? "#FFFFFF" : "#0A0C33" }}
        />
      </IconButton>
    </div>
  );
};

export default VisualizacaoToggle;
